
<div class="container-fluid">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warningForChange" appendTo="body" [closable] = "false"></p-confirmDialog>
  <div class="row" style="margin-top: 10px;" style="padding: 0px;">
    <div class="col-12 flex">
      <div class="p-0" [ngClass]="{'col-1':!showFilter, 'col-3':showFilter}">
        <div class="col-12 flex p-0">

          <div class="col-11 p-0" *ngIf="showFilter">
            <div class="col">
              <div class="row">
                <div class="col-10" id="multiselectDiv">
                  <div class="col-12">
                    <div class="ui-inputgroup" id="filterLabel">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
                      <p-multiSelect [options]="filterOptions" optionLabel="label" optionValue="value" (onChange)="onApplyFilter()" [(ngModel)]="selectedStates"
                        id="multiselectStatuses"[style]="{'width':'68%','padding':'2%'}">
                        <ng-template let-item pTemplate="selectedItem">
                          <span style="vertical-align:middle">{{item.label}}</span>
                        </ng-template>
                        <ng-template let-status pTemplate="item">
                          {{status.label}}
                        </ng-template>
                      </p-multiSelect>
                    </div>
                  </div>
                </div>
                <div class="col-2" id="refreshBatchesDiv">
                  <button pButton class="refreshBatches h-2rem" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
                </div>
                <div class="row p-0 justify-content-between" id="datePicker">
                  <div class="col-6 p-1">
                    <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                      [dateFormat]="dateFormat" [showIcon]="true" placeholder="From"
                      showButtonBar="true" (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()"
                      [maxDate]="toDate"></p-calendar>
                  </div>
                  <div class="col-6 p-1">
                    <p-calendar [(ngModel)]="toDate" [minDate]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                      [dateFormat]="dateFormat" [showIcon]="true" placeholder="To"
                      showButtonBar="true" (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()"></p-calendar>
                  </div>
                </div>
                <div class="row col-12 flex" style=" margin-left: 1%;">
                  <label class="m-0">Number Of Batches Matching Filter: <label class="m-0 font-weight-bold text-success"
                      style="font-size: 1.2rem;">{{batches == null ? 0: batches.length}}</label></label>
                </div>
                <p-table [value]="batches" selectionMode="single" [scrollable]="true" scrollHeight="80vh"
                  (onRowSelect)="batchViewVisbility($event)" [loading]="loading">
                  <ng-template pTemplate="header">
                    <tr>
                      <th scope="col" style="width: 40%;" class="batch">Batch ID</th>
                      <th scope="col" class="status">Status</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-batch>
                    <tr [pSelectableRow]="batch">

                      <td style="width: 40%;"
                        [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                        {{batch?.batchID}}</td>
                      <td
                        [class]="(batch?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                        {{batch?.statusOfTheBatch}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
          <div [class]="showFilter ? 'col-1 pr-0' : 'col-3 pr-0 float-right'">
            <p-toggleButton [(ngModel)]="showFilter" onLabel="" offLabel="" onIcon="fa fa-chevron-circle-left"
              offIcon="fa fa-chevron-circle-right" [style]="{'width':'96%','height':'2.5rem','margin-top':'20rem'}"></p-toggleButton>
            </div>
          </div>
        </div>
      <div [class]="showFilter ? 'col-9' :'col-11'" style=" border-left: 1px solid #186BA0;">
        <div class="col-12 flex" id="topGroup">
          <div class="col-4" style="padding: 0% 0% 2% 0%;">
            <div class="ui-inputgroup userIdLable" style="margin-top: 10px;">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID" style="width: 44%;"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4"
              style="width: 55%; border-radius: 1px; height: 32px;" placeholder="User ID" readonly  />
            </div>
            <div class="flex ui-inputgroup userIdLable" style="margin-top: 10px;">
              <div style="width:44%">
              <p-dropdown  [style]="{'width':'101%'}"  placeholder="Choose Search"
              [options]="searchFilterList"  name="searchFilterList" [(ngModel)]="selectedSearchFilter">
              </p-dropdown></div>
              <input pInputText name="SearchSample" [(ngModel)]="valueToSearch" size="17"
              (keydown.enter)="searchForBatchWIthFilter()" style=" border-radius: 1px;width: 50%; height: 33px;" />
              <button pButton icon="fa fa-search"  style="width: 5%; height: 33px;" [disabled]="searchButtonDisabledIf()"  (click)="searchForBatchWIthFilter()">
              </button>
          </div>
          </div>
            <div class="col-5 topDivspacing" style="text-align:left;margin: 0px 0px 3px;padding: 0% 0% 2%;">
            <div class="col-12 flex headers topDivspacing" style="height: 32px;" id="topDiv">
              <div class="col-3">
              <h5 style="color:#1F89CE; font-size: 19px;">
                  Batch</h5> </div>
                  <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                  <h5>
                  :
              </h5>
            </div>
              <div class="col-8">
                <h5 style="color:#1F89CE; font-size: 19px;">
                <strong style="margin: 3%;">{{selectedBatch?.batchID}}</strong>
                </h5>
              </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-3">
              <h5  style="color:#1F89CE; font-size: 19px;">
                  Status
                </h5></div>
                <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                  <h5>
                  :
              </h5>
            </div>
                <div class="col-8">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedBatch?.statusOfTheBatch}} </strong>
                </h5>
                </div>
            </div>
            <div class="col-12 flex headers" style="height: 32px;">
              <div class="col-3">
              <h5 style="color:#1F89CE; font-size: 19px;">
                  Sender
                </h5></div>
                <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                  <h5>
                  :
              </h5>
            </div>
                <div class="col-8">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{getfunction()}} </strong>
                </h5>
              </div>
          </div>
            <div  class="col-12 flex headers" style="height: 32px;">
              <div class="col-3">
              <h5 style="color:#1F89CE; font-size: 19px;">
                  Samples  </h5></div>
                  <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                    <h5>
                    :
                </h5>
              </div>
                <div class="col-8">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedBatch?.samples?.length}} </strong>
                </h5>
              </div>
          </div>
            <div  class="col-12 flex headers" style="height: 32px;">
              <div class="col-3">
              <h5 style="color:#1F89CE; font-size: 19px; width: 120px;">
                  External Id </h5></div>
                  <div  style="color:#1F89CE; font-size: 19px;"class="col-1">
                    <h5>
                    :
                </h5>
              </div>
                <div class="col-8">
                  <h5 style="color:#1F89CE; font-size: 19px;">
                  <strong style="margin: 3%;">{{selectedBatch?.externalIdentification}} </strong>
                </h5>
              </div>
          </div>
        </div>



          <div class="col-3 topDivspacing pl-0">
            <div class="ui-inputgroup pl-0 flex" id="inputClass">
              <div>
                <button pButton class="w-full theme-button noHover labelButton" type="button" label="History"></button>
                <p-dropdown *ngIf="selectedBatch.wellType == 'WELL384'" [style]="{'width':'150px'}" [options]="groupedBatches" [(ngModel)]="batchHistoryId"
                  placeholder="Select a Batch" [group]="true" (onChange)="searchBatch()" scrollHeight="500px">
                  <ng-template let-group pTemplate="group">
                    <div class="p-d-flex p-ai-center mt-2">
                      <span>{{group.label}}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>

              <div style="width: 52%;">
              <p-dropdown *ngIf="selectedBatch.wellType == 'WELL96'" [style]="{'width':'115%'}" [options]="batchHistory" [(ngModel)]="batchHistoryId"
                placeholder="Select a Batch"  (onChange)="searchBatch()">
              </p-dropdown></div>
            </div>
            <div>
              <button pButton type="button" [ngStyle]="buttonsRound" [icon]="getViewPlateIcon(showPlateView)" [label]="getPlateViewButtonLabel(showPlateView)"
                id="plateView" (click)="togglePlateView()" [disabled]="!selectedBatch.batchID || (selectedBatch.samples && selectedBatch.samples.length == 0)"></button>
            </div>
            <div>
              <button pButton *ngIf="showPlateView" [ngStyle]="buttonsRound" style="width:95% ;height: 95%;" [label]="getAnalysisButtonLabel()" [disabled]="!selectedBatch.resultsImported"
                class="thirdButton" (click)="toggleAnalysisView()"></button>
            </div>
          </div>
        </div>
        <div class="col-12 flex" id="tableDiv" *ngIf="!showPlateView">
          <fieldset [disabled]= isAllMidplexButtonsDisable()>
            <legend></legend>
            <div class="col-12 flex" id="tableDiv">
            <table aria-describedby="Processing table" id="processingTable"
              style="border: 1px solid black; width: 100%; height: 100%; table-layout: fixed;">
              <thead id="processingTableHeader">
                <tr>
                  <th scope="col">Batch Reception</th>
                  <th scope="col">ARTIC QC</th>
                  <th scope="col">Lib Prep pre-PCR</th>
                  <th scope="col">Lib Prep post-PCR</th>
                  <th scope="col">Seq Data Processing</th>
                </tr>
              </thead>
              <tbody class="processingTableBody">
                <tr>
                  <td class="processingTableBody"
                    [ngClass]="{ 'disableTD': enableIfStatusIn(['BATCH_UPLOADED'])}">

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Receive Batch" (click)="saveBatchStatus('BATCH_RECEIVED')"
                          [disabled]="enableIfStatusIn(['BATCH_UPLOADED']) || disableReceiveBatch()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.batchReceivedDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.batchReceivedPUID}}
                      </div>
                    </div>
                  </td>
                  <td class="processingTableBody"
                    [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_ARTIC_POOLING', 'START_ARTIC_PURIFICATION'])}">
                    <div class="col-12 parent">

                      <div class="col-12 p-0 flex parent">

                        <div class="col-8 child">
                          <button pButton label="Start ARTIC Purification" (click)="saveBatchStatus('START_ARTIC_PURIFICATION')"
                            class="buttonsRound startButton"
                            [disabled]="enableIfStatusIn(['COMPLETE_ARTIC_POOLING', 'START_ARTIC_PURIFICATION']) || disableStartPurification1()">
                          </button>
                        </div>

                        <div class="col-4 sibling">
                          {{selectedBatch?.startArticPurificationDateTime | date: dateTimeFormat}} <br />
                          {{selectedBatch?.startArticPurificationPUID}}
                        </div>
                      </div>
                      <div class="col-12 p-0 flex parent">
                        <div class="col-8 child">
                          <button pButton label="Complete ARTIC Purification" (click)="saveBatchStatus('COMPLETE_ARTIC_PURIFICATION')"
                            [disabled]="enableIfStatusIn(['COMPLETE_ARTIC_POOLING', 'START_ARTIC_PURIFICATION']) || disableCompletePurification1()"
                            class="buttonsRound thirdButton"></button>
                        </div>
                        <div class="col-4 sibling">
                          {{selectedBatch?.completeArticPurificationDateTime | date: dateTimeFormat}} <br />
                          {{selectedBatch?.completeArticPurificationPUID}}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="processingTableBody"  [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_NORMALIZATION', 'START_END_REPAIR'])}">

                    <div class="col-12 flex parent">

                      <div class="col-8 child">
                        <button pButton label="Start End Repair" (click)="saveBatchStatus('START_END_REPAIR')"
                          class="buttonsRound startButton"
                          [disabled]="enableIfStatusIn(['COMPLETE_NORMALIZATION', 'START_END_REPAIR']) || disableStartEndRepair() ">
                        </button>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.startEndRepairDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startEndRepairPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete End Repair" (click)="saveBatchStatus('COMPLETE_END_REPAIR')"
                          [disabled]="enableIfStatusIn(['COMPLETE_NORMALIZATION', 'START_END_REPAIR']) || disableCompleteEndRepair()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeEndRepairDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeEndRepairPUID}}
                      </div>
                    </div>
                  </td>
                  <td rowspan="3" class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_TAG_PCR', 'START_LIB_QC'])}">
                    <div class="col-12 flex parent">

                        <div class="col-8 child">
                          <button pButton label="Create Pool Library" (click)="createPoolIdForTheBatch()"
                            class="buttonsRound startButton"
                            [disabled]="disableCreateSampleButton()">
                          </button>
                        </div>
                        <div class="col-4 sibling">
                          {{selectedBatch?.nglimsSampleCreationDateTime | date: dateTimeFormat}} <br />
                          {{selectedBatch?.nglimsSampleCreationPUID}}
                        </div>

                    </div>
                    <div class="col-12 flex parent" *ngIf="selectedBatch.nglimsProjectId">
                      project : {{selectedBatch?.nglimsProjectId}} <br />
                      sample : {{selectedBatch?.nglimsSampleId}} <br />
                      library Id : {{selectedBatch?.libraryId}}
                  </div>
                  </td>
                  <td class="processingTableBody" rowspan="3"
                    [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_SEQUENCING_RUN', 'START_PRIMARY_ANALYSIS','START_SECONDARY_ANALYSIS','COMPLETE_SECONDARY_ANALYSIS'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Primary Analysis" (click)="saveBatchStatus('START_PRIMARY_ANALYSIS')"
                          class="buttonsRound startButton"
                          [disabled]="enableIfStatusIn(['COMPLETE_SEQUENCING_RUN', 'START_PRIMARY_ANALYSIS','START_SECONDARY_ANALYSIS'])  || disableStartPrimaryAnalysis()">
                        </button>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.startPrimaryAnalysisDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startPrimaryAnalysisPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">

                      <div class="col-8 child">
                        <button pButton label="Start Secondary Analysis" (click)="saveBatchStatus('START_SECONDARY_ANALYSIS')"
                          class="buttonsRound startButton"
                          [disabled]="disableStartSecondaryAnalysis(['START_PRIMARY_ANALYSIS','COMPLETE_PRIMARY_ANALYSIS'])">
                        </button>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.startSecondaryAnalysisDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startSecondaryAnalysisPUID}}
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Primary Analysis" (click)="saveBatchStatus('COMPLETE_PRIMARY_ANALYSIS') "
                          [disabled]="disableCompletePrimaryAnalysis(['START_PRIMARY_ANALYSIS','START_SECONDARY_ANALYSIS','COMPLETE_SECONDARY_ANALYSIS'])"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completePrimaryAnalysisDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completePrimaryAnalysisPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Secondary Analysis" (click)="saveBatchStatus('COMPLETE_SECONDARY_ANALYSIS')"
                          [disabled]="disableCompleteSecondaryAnalysis(['COMPLETE_PRIMARY_ANALYSIS', 'START_SECONDARY_ANALYSIS'])"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeSecondaryAnalysisDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeSecondaryAnalysisPUID}}
                      </div>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['BATCH_RECEIVED'])}">
                    <div class="border-bottom headerDiv text-center">ARTIC PCR</div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton  label="Add Shuffled Controls" (click)="createProcessBatch('CONTROLS_ADDED')"
                          [disabled]="enableIfStatusIn(['BATCH_RECEIVED','CONTROLS_ADDED'])  || disableControlsAdded()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.controlsAddedDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.controlsAddedPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex" >
                      {{getNTCAndSamplePosition()}}  <br />
                      {{getPCAndSamplePosition()}}
                  </div>
                  </td>
                  <td rowspan="2" class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_ARTIC_PURIFICATION', 'START_ARTIC_QC'])}">
                    <div class="col-12 flex parent">

                      <div class="col-8 child">
                        <button pButton label="Start ARTIC QC" (click)="saveBatchStatus('START_ARTIC_QC')"
                          class="buttonsRound startButton"
                          [disabled]="enableIfStatusIn(['COMPLETE_ARTIC_PURIFICATION', 'START_ARTIC_QC']) || disableStartArticQC()">
                        </button>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.startArticQCDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startArticQCPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">

                      <div class="col-8 child">
                        <button pButton label="FLX WorkFile"
                          class="buttonsRound thirdButton"
                          [disabled]="disableIfNoControls()"
                          (click)= "downloadFLXWorkFile()">
                        </button>
                      </div>

                    </div>
                    <div class="col-12 flex parent">

                      <div class="col-8 child">
                        <p-fileUpload #fileUploaderOnArticQC [style]="getFileUploadStyle()" (uploadHandler)="onFLXUpload($event, fileUploaderOnArticQC)" mode="basic"
                        customUpload="true" accept=".txt" chooseLabel="FLX Measurements" (onSelect)="onFLXFileSelect($event)" [disabled]="selectedBatch?.statusOfTheBatch != 'START_ARTIC_QC'" auto="true"></p-fileUpload>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.measuredArticQCDateTime  | date: dateTimeFormat}} <br />
                        {{selectedBatch?.measuredArticQCPUID}}
                      </div>
                    </div>
                    <div class="ui-inputgroup flex h-2rem" id="inputClass">
                      <button pButton class="theme-button noHover labelButton" type="button" label="DF"></button>
                      <p-inputNumber [showButtons]="true"  size="3" [min]="1" [max]="10" [(ngModel)]="dillusionFactorForArticQC"
                         [disabled]="selectedBatch?.statusOfTheBatch != 'START_ARTIC_QC'"
                       ></p-inputNumber>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">

                        <button pButton *ngIf="!selectedBatch?.articQCFailed" label="Complete ARTIC QC" (click)="commentPopup=true"
                          [disabled]=" enableIfStatusIn(['COMPLETE_ARTIC_PURIFICATION', 'START_ARTIC_QC']) || disableCompleteArticQC()"
                          class="buttonsRound endButton"></button>
                        <button pButton *ngIf="selectedBatch?.currentRedoBatch && selectedBatch?.batchID == selectedBatch?.currentRedoBatch
                         && selectedBatch?.articQCFailed"
                         label="QC Failed" (click)="commentPopup=true"
                          [disabled]=" enableIfStatusIn(['COMPLETE_ARTIC_PURIFICATION', 'START_ARTIC_QC']) || disableCompleteArticQC()"
                          class="buttonsRound endButton"></button>

                      </div>
                      <div  class="col-4 sibling" *ngIf="(selectedBatch?.currentRedoBatch && selectedBatch?.batchID == selectedBatch?.currentRedoBatch && selectedBatch?.statusOfTheBatch =='REDO'
                          && selectedBatch?.articQCFailed);else completeArticDate">
                          {{selectedBatch?.redoDateTime | date: dateTimeFormat}} <br />
                          {{selectedBatch?.redoPUID}}
                      </div>
                      <ng-template #completeArticDate>
                        <div class="col-4 sibling" >
                          {{selectedBatch?.completeArticQCDateTime | date: dateTimeFormat}} <br />
                          {{selectedBatch?.completeArticQCPUID}}
                        </div>
                      </ng-template>

                    </div>
                  </td>
                  <td class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_END_REPAIR', 'START_ADAPTER_LIGATION'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Adapter Ligation11" (click)="saveBatchStatus('START_ADAPTER_LIGATION')"
                          class="buttonsRound startButton"
                          [disabled]="enableIfStatusIn(['COMPLETE_END_REPAIR', 'START_ADAPTER_LIGATION']) || disableStartAdapterLigation()">
                        </button>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.startAdapterLigationDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startAdapterLigationPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Adapter Ligation" (click)="saveBatchStatus('COMPLETE_ADAPTER_LIGATION')"
                          [disabled]="enableIfStatusIn(['COMPLETE_END_REPAIR', 'START_ADAPTER_LIGATION']) || disableCompleteAdapterLigation()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeAdapterLigationDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeAdapterLigationPUID}}
                      </div>
                    </div>
                  </td>

                </tr>
                <tr>
                  <td class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['CONTROLS_ADDED', 'START_cDNA'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start cDNA" (click)="saveBatchStatus('START_cDNA')"
                          class="buttonsRound startButton"
                          [disabled]="enableIfStatusIn(['CONTROLS_ADDED', 'START_cDNA']) || disableStartcDNA()">
                        </button>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.startcDNADateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startcDNAPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="cDNA Workfile" (click)="downloadcDNAControlsWorkFile();"
                          class="buttonsRound startButton"
                          [disabled]="enableIfStatusIn(['START_cDNA']) || disablecDNAWorkFile()">
                        </button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.cDNAWorkfileDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.cDNAWorkfilePUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete cDNA" (click)="saveBatchStatus('COMPLETE_cDNA')"
                          [disabled]="enableIfStatusIn(['CONTROLS_ADDED', 'START_cDNA']) || disableCompletecDNA()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completecDNADateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completecDNAPUID}}
                      </div>
                    </div>
                  </td>
                  <td class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_ADAPTER_LIGATION', 'START_ADAPTER_LIGATION'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Purification 2" (click)="saveBatchStatus('START_PURIFICATION_2')"
                          [disabled]="enableIfStatusIn(['COMPLETE_ADAPTER_LIGATION', 'START_PURIFICATION_2']) || disableStartPurification2()"
                          class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.startPurification2DateTIme | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startPurification2PUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Purification 2" (click)="saveBatchStatus('COMPLETE_PURIFICATION_2')"
                          [disabled]="enableIfStatusIn(['COMPLETE_ADAPTER_LIGATION', 'START_PURIFICATION_2']) || disableCompletePurification2()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completePurification2DateTIme | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completePurification2PUID}}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_cDNA', 'START_ARTIC_PCR'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start ARTIC PCR" (click)="saveBatchStatus('START_ARTIC_PCR')"
                          [disabled]=" enableIfStatusIn(['COMPLETE_cDNA', 'START_ARTIC_PCR']) || disableStartArticPCR()"
                          class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.startArticPCRDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startArticPCRPUID}}
                      </div>
                    </div>
                    <div class="col-12 parent">
                      <div class="col-8 child">
                        <button pButton label="Complete ARTIC PCR" (click)="saveBatchStatus('COMPLETE_ARTIC_PCR')"
                          [disabled]="enableIfStatusIn(['COMPLETE_cDNA', 'START_ARTIC_PCR']) || disableCompleteArticPCR()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeArticPCRDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeArticPCRPUID}}
                      </div>
                    </div>
                  </td>
                  <td rowspan="2" class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_ARTIC_QC', 'START_NORMALIZATION'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Normalization" (click)="saveBatchStatus('START_NORMALIZATION')"
                          [disabled]="enableIfStatusIn(['COMPLETE_ARTIC_QC', 'START_NORMALIZATION']) || disableStartNormalization()"
                          class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.startNormalizationDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startNormalizationPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                        <div class="col-8 child">
                          <button pButton label="Lynx DNA Workfile" (click)="downloadDNAWorkFile()"
                            [disabled]="selectedBatch.statusOfTheBatch != 'START_NORMALIZATION'"
                            class="buttonsRound startButton"></button>
                        </div>

                      </div>
                      <div class="col-12 flex parent">
                          <div class="col-8 child">

                            <button pButton label="Lynx Buffer Workfile" (click)="downloadBufferWorkFile()"
                              [disabled]="selectedBatch.statusOfTheBatch != 'START_NORMALIZATION'"
                              class="buttonsRound startButton"></button>
                          </div>

                        </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Normalization" (click)="saveBatchStatus('COMPLETE_NORMALIZATION')"
                          [disabled]="enableIfStatusIn(['COMPLETE_ARTIC_QC', 'START_NORMALIZATION']) || disableCompleteNormalization()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeNormalizationDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeNormalizationPUID}}
                      </div>
                    </div>
                  </td>
                  <td rowspan="2" class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_NORMALIZATION','COMPLETE_PURIFICATION_2', 'START_TAG_PCR'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Tag PCR" (click)="saveBatchStatus('START_TAG_PCR')"
                          [disabled]="enableIfStatusIn(['COMPLETE_NORMALIZATION','COMPLETE_PURIFICATION_2', 'START_TAG_PCR']) || disableStartTagPCR()"
                          class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.startTagPCRDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startTagPCRPUID}}
                      </div>
                    </div>
                    <div class="ui-inputgroup flex" id="inputClass">
                      <button pButton class="theme-button noHover labelButton h-3rem" type="button" label="Tag Plate"></button>
                      <p-dropdown [style]="getDropdownStyle()" placeholder="Select Tag Plate"
                        [options]="tags"  [(ngModel)]="selectedTagPlate"
                        name="LightCyclers" [disabled]="enableIfStatusIn(['COMPLETE_PURIFICATION_2', 'START_TAG_PCR']) || !(selectedBatch.startTagPCRDateTime && selectedBatch.startTagPCRPUID) || disableCastDropdown()" id="PCRMachines"
                       ></p-dropdown>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Assign Tag Plate" (click)="openVerifyReceptionPopup()"
                        [disabled]="enableIfStatusIn(['COMPLETE_PURIFICATION_2', 'START_TAG_PCR']) || disableAssignTagPlate()"
                        class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.assignTagPlateDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.assignTagPlatePUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                       <div class="col-8 child"> Used Plate Barcode: {{selectedBatch?.tagPlateBarcode}}  </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Tag PCR" (click)="saveBatchStatus('COMPLETE_TAG_PCR')"
                        [disabled]="enableIfStatusIn(['COMPLETE_PURIFICATION_2', 'START_TAG_PCR']) || disableCompleteTagPCR()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeTagPCRDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeTagPCRPUID}}
                      </div>
                    </div>
                  </td>
                  <td class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_TAG_PCR', 'START_LIB_POOLING'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Lib Pooling & Final PF" (click)="saveBatchStatus('START_LIB_POOLING')"
                          [disabled]="enableIfStatusIn(['COMPLETE_TAG_PCR', 'START_LIB_QC','COMPLETE_LIB_QC', 'START_LIB_POOLING']) || disableStartLibPooling()"
                          class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.startLibPoolingDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startLibPoolingPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Lib Pooling & Final PF" (click)="saveBatchStatus('COMPLETE_LIB_POOLING')"
                          [disabled]="enableIfStatusIn(['COMPLETE_TAG_PCR', 'START_LIB_QC','COMPLETE_LIB_QC','START_LIB_POOLING']) || disableCompleteLibPooling()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeLibPoolingDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeLibPoolingPUID}}
                      </div>
                    </div>
                  </td>
                  <td rowspan="2" class="processingTableBody" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_SECONDARY_ANALYSIS', 'START_DATA_REVIEW', 'READY_FOR_DELIVERY'])}">
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Data Review" (click)="saveBatchStatus('START_DATA_REVIEW')"
                          [disabled]="enableIfStatusIn(['COMPLETE_PRIMARY_ANALYSIS','COMPLETE_SECONDARY_ANALYSIS', 'START_DATA_REVIEW', 'READY_FOR_DELIVERY']) || disableStartDataReview()"
                          class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.startDataReviewDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startDataReviewPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child" *ngIf="!selectedBatch?.dataReviewFailed">
                        <button pButton label="Complete Data Review" (click)="commentPopup=true"
                          [disabled]="enableIfStatusIn(['COMPLETE_SECONDARY_ANALYSIS', 'START_DATA_REVIEW']) || disableCompleteDataReview()"
                          class="buttonsRound" [ngClass]="{'endButton': !selectedBatch.readyForDeliveryDateTime, 'startButton':selectedBatch.readyForDeliveryDateTime}"></button>
                      </div>
                      <div class="col-8 child" *ngIf="selectedBatch?.currentRedoBatch && selectedBatch?.batchID == selectedBatch?.currentRedoBatch
                         && selectedBatch?.dataReviewFailed">
                        <button pButton label="QC Failed" (click)="commentPopup=true"
                          [disabled]="enableIfStatusIn(['COMPLETE_SECONDARY_ANALYSIS', 'START_DATA_REVIEW']) || disableCompleteDataReview()"
                          class="buttonsRound" [ngClass]="{'endButton': selectedBatch.dataReviewFailed}"></button>
                      </div>
                      <div class="col-4 sibling" *ngIf="selectedBatch?.currentRedoBatch && selectedBatch?.batchID == selectedBatch?.currentRedoBatch && selectedBatch?.statusOfTheBatch =='REDO'
                          && selectedBatch?.dataReviewFailed;else completeDataReviewElse">
                          {{selectedBatch?.redoDataReviewQCDateTime | date: dateTimeFormat}} <br />
                          {{selectedBatch?.redoDataReviewQCPUID}}
                       </div>
                       <ng-template #completeDataReviewElse>
                        <div class="col-4 sibling">
                          {{selectedBatch?.readyForDeliveryDateTime | date: dateTimeFormat}} <br />
                          {{selectedBatch?.readyForDeliveryPUID}}
                        </div>
                       </ng-template>

                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Delivery" [disabled]="true"
                          class="buttonsRound" class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.startDeliveryDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startDeliveryPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Delivered" (click)="saveBatchStatus('COMPLETED')"
                        [disabled]="enableIfStatusIn(['START_DELIVERY']) || disableDelivered()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.deliveryCompletionDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.deliveryCompletionPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Invoiced" [disabled]="true"
                          class="buttonsRound" class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.invoicedDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.invoicedPUID}}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="processingTableBody"
                    [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_ARTIC_PCR', 'START_ARTIC_POOLING'])}">
                    <div class="col-12 flex parent">

                      <div class="col-8 child">
                        <button pButton label="Start ARTIC Pooling" (click)="saveBatchStatus('START_ARTIC_POOLING')"
                          class="buttonsRound startButton"
                          [disabled]="enableIfStatusIn(['COMPLETE_ARTIC_PCR', 'START_ARTIC_POOLING']) || disableStartArticPooling()">
                        </button>
                      </div>

                      <div class="col-4 sibling">
                        {{selectedBatch?.startArticPoolingDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.startArticPoolingPUID}}
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete ARTIC Pooling" (click)="saveBatchStatus('COMPLETE_ARTIC_POOLING')"
                          [disabled]="enableIfStatusIn(['COMPLETE_ARTIC_PCR', 'START_ARTIC_POOLING']) || disableCompleteArticPooling()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completeArticPoolingDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completeArticPoolingPUID}}
                      </div>
                    </div>
                  </td>
                  <td class="processingTableBody"
                  [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_LIB_POOLING', 'START_FINAL_QC'])}">
                  <div class="col-12 flex parent">

                    <div class="col-8 child">
                      <button pButton label="Start final QC (FLX + FA)" (click)="saveBatchStatus('START_FINAL_QC')"
                        class="buttonsRound startButton"
                        [disabled]="enableIfStatusIn(['COMPLETE_LIB_POOLING', 'START_FINAL_QC']) || disableStartFinalQC()">
                      </button>
                    </div>

                    <div class="col-4 sibling">
                      {{selectedBatch?.startFinalQCDateTime | date: dateTimeFormat}} <br />
                      {{selectedBatch?.startFinalQCPUID}}
                    </div>
                  </div>
                  <div class="col-12 flex parent">
                    <div class="col-8 child">
                      <button pButton *ngIf="!selectedBatch?.finalQCFailed" label="Complete final QC (NGLIMS)" (click)="commentPopup=true"
                        [disabled]="enableIfStatusIn(['COMPLETE_LIB_POOLING', 'START_FINAL_QC']) || disableCompleteFinalQC()"
                        class="buttonsRound endButton"></button>
                      <button pButton *ngIf="selectedBatch?.currentRedoBatch && selectedBatch?.batchID == selectedBatch?.currentRedoBatch &&
                        selectedBatch?.finalQCFailed" label="QC Failed" (click)="commentPopup=true"
                        [disabled]="enableIfStatusIn(['COMPLETE_LIB_POOLING', 'START_FINAL_QC']) || disableCompleteFinalQC()"
                        class="buttonsRound endButton"></button>
                    </div>
                    <div class="col-4 sibling" *ngIf="selectedBatch?.currentRedoBatch && selectedBatch?.batchID == selectedBatch?.currentRedoBatch && selectedBatch?.statusOfTheBatch =='REDO'
                         && selectedBatch?.finalQCFailed;else completeFinalQCDate">
                      {{selectedBatch?.redoFinalQCDateTime | date: dateTimeFormat}} <br />
                      {{selectedBatch?.redoFinalQCPUID}}
                    </div>
                    <ng-template #completeFinalQCDate>
                    <div class="col-4 sibling">
                      {{selectedBatch?.completeFinalQCDateTime | date: dateTimeFormat}} <br />
                      {{selectedBatch?.completeFinalQCPUID}}
                    </div>
                    </ng-template>
                  </div>
                </td>

                </tr>
                <tr>
                  <td colspan="2" class="processingTableBody pt-0 pr-0">
                    <div class="border-bottom headerDiv text-center">Comments</div>
                    <div class="col-12" style="height: 100%; ">
                      <div class="col-12 flex">
                        <div class="col-6 p-0 text-left">
                          <label class="font-weight-bold commentBatchId">{{previewComment?.batchId}}</label>
                        </div>
                        <div class="col-6 p-0 text-right">
                          <label class="commentPUIDDate">{{previewComment?.puid}} | {{previewComment?.commentDate | date: dateTimeFormat}}</label>
                        </div>
                      </div>
                      <textarea [(ngModel)]="previewComment.userComment" type="text" name="comment"
                        placeholder="No comments entered" rows="5" id="commentArea" readonly></textarea>
                      <button style="margin-top: 2%;" pButton class="font-weight-bold commentButton" [disabled]="isCommentAdditionDisabled()" label="View/Add Comments" (click)="showComments()"></button>
                    </div>
                  </td>
                  <td class="processingTableBody disableTD">
                  </td>
                  <td class="processingTableBody pt-0 pr-0" [ngClass]="{ 'disableTD': enableIfStatusIn(['COMPLETE_FINAL_QC', 'TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN'])}">
                    <div class="border-bottom headerDiv text-center">Sequencing</div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Transfer To Sequencing" (click)="saveBatchStatus('TRANSFER_SEQUENCING')"
                          [disabled]="enableIfStatusIn(['COMPLETE_FINAL_QC', 'TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN']) || disableTransferSequencing()"
                          class="buttonsRound startButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.transferSequencingDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.transferSequencingPUID}}
                      </div>
                    </div>

                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Start Sequencing Run"
                          [disabled]="enableIfStatusIn(['COMPLETE_FINAL_QC', 'TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN']) || (selectedBatch.runAndLaneIdInfo && selectedBatch.runAndLaneIdInfo.length > 0)"
                          class="buttonsRound startButton"></button>
                      </div>
                    </div>
                    <div class="col-12 flex parent" *ngIf="selectedBatch.runAndLaneIdInfo && selectedBatch.runAndLaneIdInfo.length > 0">
                      <div class="col-8 child">
                        <label class="m-0"> {{getRunInformation()}} </label>
                      </div>
                      <div class="col-4 sibling">
                        {{getStartRunDateTime() | date: dateTimeFormat}} <br />
                      </div>
                    </div>
                    <div class="col-12 flex parent">
                      <div class="col-8 child">
                        <button pButton label="Complete Sequencing Run" (click)="saveBatchStatus('COMPLETE_SEQUENCING_RUN')"
                          [disabled]="enableIfStatusIn(['COMPLETE_FINAL_QC', 'TRANSFER_SEQUENCING', 'START_SEQUENCING_RUN']) || disableCompleteSequencing()"
                          class="buttonsRound thirdButton"></button>
                      </div>
                      <div class="col-4 sibling">
                        {{selectedBatch?.completedSequencingDateTime | date: dateTimeFormat}} <br />
                        {{selectedBatch?.completedSequencingPUID}}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </fieldset >
        </div>
        <div class="col-12 flex p-0" *ngIf="showPlateView">
          <app-plate-view #plateView *ngIf="showPlateView" (valueChange)='getChangedValue($event)' [selectedBatch]="selectedBatch" [puid]="puid" [selectedLabId]="selectedLabId" [totalPCRControls]="totalPCRControls"
           [showPlateView]="showPlateView" [viewMode]="plateViewMode"></app-plate-view>
      </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="{{selectedBatch.batchID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" >
  <div class="border border-info" id="commentShowDiv">
    <div class="col-12" *ngFor="let batch of getCommentKeys(commentsMap)">
      <div class="col-12 p-0 rounded border border-secondary commentBubble">
        <div class="col-12 flex">
          <div class="col-11 p-0">
            <label>{{batch}}</label>
          </div>
          <div class="col-1 p-0">
            <button *ngIf="batchCommentVisibility.get(batch)" type="button" class="float-right btn btn-outline-secondary border-0 p-0" (click)="toggleBatchContent(batch, false)"><em class="fa fa-window-minimize"></em></button>
            <button *ngIf="!batchCommentVisibility.get(batch)" type="button" class="float-right btn btn-outline-secondary border-0 p-0" (click)="toggleBatchContent(batch, true)"><em class="fa fa-window-maximize"></em></button>
          </div>
        </div>

        <div *ngIf="batchCommentVisibility.get(batch)">
          <div *ngFor="let comment of commentsMap.get(batch)">
            <div class="col-12 p-0 commentBubbleSection">
              <div class="col-12 commentPUIDDate">
                <label>{{comment.puid}} | {{comment.commentDate | date: dateTimeFormat}}</label>
              </div>
              <div class="col-12 flex commentPUIDDate font-weight-bold">
                <p>{{comment.userComment}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..." [(ngModel)]="this.newComment.userComment"></textarea>
  </div>
  <p-footer>
    <button pButton class="h-2rem border-round" label="Add Comment" [disabled]="!(newComment.userComment != null && newComment.userComment.trim() != '')" (click)="saveComment()"></button>
  </p-footer>
</p-dialog>


<p-dialog header="Confirmation" [(visible)]="commentPopup" [modal]="true" [dismissableMask]="true">
  <label class="font-weight-bold">Select appropriate option to proceed: </label>

  <p-footer>
    <button pButton class="bg-success" label="QC OK -> Continue"  (click)="completeStatus()"></button>
    <button pButton class="bg-danger" label="QC Failed -> Redo cDNA"  (click)="redoBatch('CONTROLS_ADDED')"></button>
    <button pButton class="bg-danger" *ngIf="['START_LIB_QC','START_DATA_REVIEW', 'START_FINAL_QC'].includes(selectedBatch.statusOfTheBatch)" label="QC Failed -> Redo Normalization"  (click)="redoBatch('COMPLETE_ARTIC_QC')"></button>
    <button pButton class="bg-danger" *ngIf="['START_DATA_REVIEW'].includes(selectedBatch.statusOfTheBatch)" label="QC Failed -> Redo Sequencing" (click)="redoBatch('TRANSFER_SEQUENCING')"></button>
    <button pButton class="bg-danger" *ngIf="['START_DATA_REVIEW'].includes(selectedBatch.statusOfTheBatch)" label="QC Failed -> Redo Analysis" (click)="redoBatch('COMPLETE_SEQUENCING_RUN')"></button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="missingFilesPopUp" header="Error" [modal]="true">
  <label class="font-weight-bold text-danger">
    These mandatory files are yet to be uploaded. Please upload them to proceed:
  </label>
  <div *ngFor="let missingPattern of missingPatterns">
    <label class="font-weight-bold text-danger">{{missingPattern.pattern}}.{{missingPattern.fileType}}</label>
  </div>
  <p-footer>
    <button pButton label="OK" (click)="missingFilesPopUp = false"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Enter Tag Plate Barcode" [(visible)]="verifyReceptionPUID"
      [modal]="true">
  <label class="text-danger">Scan the barcode of the Tag Plate</label>
  <div>
    <input class="batchInput" id="enteredScanPlateBarcode"  pInputText #focus1 type="text"
    [(ngModel)]="enteredScanPlateBarcode" maxlength="100" name="comment"
     placeholder="Enter Tag Plate Barcode" />
  </div>
  <div class="mt-2">
    <input class="batchInput" id="enteredPuid"  pInputText  type="text" [(ngModel)]="enteredPuid" maxlength="100" name="comment"
     placeholder="Enter User ID"  />
  </div>
  <div class="mt-2">
    <input class="batchInput" pInputText type="password" [(ngModel)]="enteredPassword" maxlength="100"
     name="comment12" placeholder="Enter Password" (keyup.enter)="verifyReceptionPUIDAction(enteredScanPlateBarcode,enteredPuid, enteredPassword)" />
  </div>
  <p-footer>
    <button pButton type="button" [disabled]="assignButtonDisabled()" label="Assign" (click)="verifyReceptionPUIDAction(enteredScanPlateBarcode,enteredPuid, enteredPassword)"></button>
  </p-footer>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
